import * as React from "react"
import { Typography } from '@mui/material'


export default function discountColumn() {
return {
		name: 'Descuento',
		label: 'Descuento',
		options: {
			customBodyRowRenderLite: value => <Typography sx={{ textAlign: 'center' }}>
				{value + '%'}
			</Typography>
		}
	}
}